// frontend/src/App.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';

// Context providers
import { PresentationProvider } from './context/PresentationContext';
import { I18nProvider } from './context/I18nContext';
import { AuthProvider } from './context/AuthContext';
import { FarmProvider } from './context/FarmContext';

// Pages
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import Dashboard from './pages/Dashboard';
import PlotDetail from './pages/PlotDetail';
import DeviceDetail from './pages/DeviceDetail';
//import NotFound from './pages/NotFound';

// Components
//import ProtectedRoute from './components/ProtectedRoute';
import Navigation from './components/Navigation';
import AddSite from './components/AddSite'; // Import the onboarding component

import './App.css';

// Set global default so all axios requests automatically carry cookies
axios.defaults.withCredentials = true;

function App() {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  //const [error, setError] = useState(null);

  // Check authentication on mount
  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await axios.get('/auth/me', {
        withCredentials: true
      });
      setUser(response.data);
    } catch (err) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <AuthProvider user={user} setUser={setUser}>
      <PresentationProvider mode={user?.presentationMode || 'default'}>
        <I18nProvider language={user?.language || 'en'}>
          <FarmProvider>
          <Router>
            {user && <Navigation />}
            <Routes>
              {!user ? (
                <>
                  <Route path="/login" element={<LoginPage onLoginSuccess={checkAuth} />} />
                  <Route path="/register" element={<RegisterPage onRegisterSuccess={checkAuth} />} />
                  <Route path="*" element={<Navigate to="/login" replace />} />
                </>
              ) : (
                <>
                  {/* Added missing route for site onboarding */}
                  <Route path="/farms/new" element={<AddSite />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/dashboard/farm/:farmId" element={<Dashboard />} />
                  <Route path="/dashboard/farm/:farmId/plot/:plotId" element={<PlotDetail />} />
                  <Route path="/dashboard/farm/:farmId/plot/:plotId/device" element={<DeviceDetail />} />
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </>
              )}
            </Routes>
          </Router>
          </FarmProvider>
        </I18nProvider>
      </PresentationProvider>
    </AuthProvider>
  );
}

export default App;
